import { useLang } from "@/lib/i18n";

export const LangToggle = ({ className = "" }) => {
  const { lang, setLang, t } = useLang();
  return (
    <div data-testid="lang-toggle" title={t("bahasa")} className={`inline-flex items-center rounded-md border border-slate-200 bg-slate-50 p-0.5 text-[11px] font-semibold ${className}`}>
      {[["id", "ID"], ["ja", "日本語"]].map(([v, l]) => (
        <button key={v} type="button" data-testid={`lang-${v}`} onClick={() => setLang(v)} aria-pressed={lang === v}
          className={`px-2 py-1 rounded transition-colors ${lang === v ? "bg-slate-900 text-white" : "text-slate-600 hover:text-slate-900"}`}>{l}</button>
      ))}
    </div>
  );
};
